// extracted by mini-css-extract-plugin
export var actions = "_ig-g";
export var benefitCard = "_ig-b";
export var benefitIcon = "_ig-d";
export var benefitLabel = "_ig-f";
export var benefits = "_ig-a";
export var benefitsSection = "_ig-8";
export var bodyText = "_ig-7";
export var closeButton = "_ig-2";
export var content = "_ig-3";
export var eyebrow = "_ig-4";
export var heading = "_ig-5";
export var image = "_ig-i";
export var imagePanel = "_ig-h";
export var modal = "_ig-0";
export var offerCard = "_ig-c";
export var offerIcon = "_ig-e";
export var sectionLabel = "_ig-9";
export var shell = "_ig-1";
export var title = "_ig-6";